export default popup => ['eraser', 'highlighter', 'redact'].includes(popup.type);



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/isHoverPopup.jsx